import { render, staticRenderFns } from "./btn-clave-unica.vue?vue&type=template&id=7fa66a32&scoped=true"
import script from "./btn-clave-unica.vue?vue&type=script&lang=js"
export * from "./btn-clave-unica.vue?vue&type=script&lang=js"
import style0 from "./btn-clave-unica.vue?vue&type=style&index=0&id=7fa66a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa66a32",
  null
  
)

export default component.exports